import React from 'react';
import { MailIcon, GlobeIcon } from 'lucide-react';
export function Footer() {
  return <footer className="w-full bg-forest-dark px-5 py-12 sm:px-8" data-id="element-63" data-mp="3gfsmscqd8umz">
      <div className="mx-auto flex max-w-5xl flex-col gap-6 sm:flex-row sm:items-center sm:justify-between" data-id="element-64" data-mp="3ghc0pwojutll">
        <p className="font-display text-xl font-semibold tracking-tight text-cream" data-id="element-65" data-mp="32m1ef7odfgsu">
          NUEVO NIVEL<sup className="text-[0.6em]" data-id="element-66" data-mp="36n3bbhutfgrn">™</sup>
        </p>
        <ul className="flex flex-col gap-3 text-sm text-cream/70 sm:flex-row sm:items-center sm:gap-6" data-id="element-67" data-mp="3ugbrpazjbkkx">
          <li data-id="element-68" data-mp="387drhtbj3d5">
            <a href="mailto:soportenuevonivel@gmail.com" className="inline-flex items-center gap-2 transition-colors hover:text-cream" data-id="element-69" data-mp="37xv6falryhh">
              <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-70" data-mp="3qc445h4tcaoa" />
              soportenuevonivel@gmail.com
            </a>
          </li>
          <li data-id="element-71" data-mp="2a1jjb8zn5u2g">
            <a href="https://www.nuevonivel.shop" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 transition-colors hover:text-cream" data-id="element-72" data-mp="2ey09e8qeiii6">
              <GlobeIcon className="h-4 w-4" aria-hidden="true" data-id="element-73" data-mp="3gbqz6ionarch" />
              www.nuevonivel.shop
            </a>
          </li>
        </ul>
      </div>
      <p className="mx-auto mt-8 max-w-5xl border-t border-cream/10 pt-6 text-xs leading-relaxed text-cream/45" data-id="element-74" data-mp="3q8n0o4g4md7j">
        © Nuevo Nivel™ 2025 — Producto informativo y educativo. No reemplaza
        consulta médica profesional.
      </p>
    </footer>;
}